export default "__VITE_ASSET__BlP8E9xM__"